<template>
  <v-card
      flat
      v-if="items.length > 0"
      rounded="0"
      class="mx-auto mt-4"
      max-width="800"
      mim-width="350"
  >
    <v-container class="pt-2 pb-0" fluid>
      <v-row class="ma-0 mt-2" v-if="isAuth">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            연락처
          </v-card-text>
        </v-col>
        <v-col cols="7" class="pa-0">
          <v-text-field v-model="orderPhoneNumber" maxlength="20" disabled="true" class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
        </v-col>
      </v-row>

      <v-row class="ma-0 mt-2" v-if="!isAuth">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            연락처
          </v-card-text>
        </v-col>
        <v-col cols="7" class="pa-0">
          <v-text-field v-model="orderPhoneNumber" maxlength="20" class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
        </v-col>
        <v-col cols="3" class="pa-0 pl-3">
          <v-btn
              class="w-100 h-100 bg-primary"
              @click.prevent="onSendSMS"
              :disabled="isAuthClickBtn"
              variant="flat">
            인증
          </v-btn>
        </v-col>
      </v-row>

      <div v-if="!isAuth && isSmsClickBtn">
        <v-row class="ma-0 mt-3">
          <v-col cols="12" class="pa-0">
            <v-checkbox v-model="agree" density="compact" hide-details>
              <template v-slot:label>
                <div class="text-body-2">
                  정보제공 동의
                  <v-dialog v-model="dialog" transition="dialog-bottom-transition">
                    <template v-slot:activator="{ props }">
                      <a class="font-weight-bold text-decoration-underline" @click="dialog = true">보기</a>
                    </template>
                    <v-card>
                      <v-card-text>
                        <p v-html="board"></p>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            class="text-primary font-weight-bold"
                            variant="text"
                            @click="[agree = false, dialog = false]"
                        >
                          미동의
                        </v-btn>
                        <v-btn
                            class="text-primary font-weight-bold"
                            variant="text"
                            @click="[agree = true, dialog = false]"
                        >
                          동의
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  (필수)
                </div>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>

        <v-row class="ma-0">
          <v-col cols="3" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              인증번호
            </v-card-text>
          </v-col>
          <v-col cols="6" class="pa-0">
            <v-text-field v-model="smsAuthNumber" maxlength="4" class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
          </v-col>
          <v-col cols="3" class="pa-0 pl-3">
            <v-btn
                class="w-100 h-100 bg-primary"
                @click.prevent="onLogin"
                variant="flat">
              확인
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="ma-0 mt-1">
          <v-col cols="3" class="pa-0">
          </v-col>
          <v-col cols="9" class="pa-0">
            <v-card-text class="pa-0 pl-1 text-body-2">
              {{timerStr}}
            </v-card-text>
          </v-col>
        </v-row>
      </div>
    </v-container>

    <v-divider class="mt-4 mb-3"></v-divider>

    <v-container v-if="membershipInfo.length > 0" class="pt-0 pb-2" fluid>
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0 mb-2">
          <v-card-text class="pa-0 font-weight-bold text-body-2 text-start">
            할인/쿠폰
          </v-card-text>
        </v-col>
        <v-col cols="9" class="pa-0">
          <v-select
              :items="membershipInfo"
              v-model="selectedMembership"
              @update:modelValue="getDiscountAmount"
              class="bg-white"
              density="compact"
              variant="outlined"
              location="bottom"
              item-title="value"
              item-value="key"
              single-line
              label="할인/쿠폰 선택"
              hide-details></v-select>
        </v-col>
        <v-col cols="3" class="pa-0 pl-3">
          <v-btn
              class="w-100 h-100 bg-primary"
              @click="getCartItemList"
              variant="flat"
              :disabled="this.selectedMembership == ''">
            초기화
          </v-btn>
        </v-col>
      </v-row>

      <v-card class="mt-4" color="grey-darken-1" variant="outlined">
        <v-container fluid>
          <v-row class="pa-1">
            <v-card-text class="pa-0 text-start text-body-2 font-weight-bold">적용 결과</v-card-text>
            <v-card-text class="pa-0 text-end text-body-2 font-weight-bold">{{discountResultMessage}}</v-card-text>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
    <v-container class="pt-0 pb-0" fluid>
      <v-card class="pa-2 mt-2" v-for="item in items" color="grey-lighten-3" variant="flat">
        <v-container fluid>
          <v-row class="pa-1">
            <v-col cols="12" class="pa-0">
              <v-card-text class="pa-0 text-body-1 font-weight-bold">{{item.menu_name}}</v-card-text>
            </v-col>
          </v-row>
          <v-row class="pl-1 pr-1 text-end">
            <v-col cols="8" class="pa-0">
              <v-card-text class="pa-0 text-caption">{{formatAmt(item.unit_price)}} X {{item.sale_cnt}}개</v-card-text>
            </v-col>
            <v-col cols="4" class="pa-0">
              <v-card-text class="pa-0 text-body-2 font-weight-bold">{{formatAmt(item.unit_price * item.sale_cnt)}}</v-card-text>
            </v-col>
          </v-row>
          <v-row v-if="item.dc_amt" class="pl-1 pr-1 text-end">
            <v-col cols="8" class="pa-0">
              <v-card-text class="pa-0 text-red text-caption">{{item.dc_rate}}%</v-card-text>
            </v-col>
            <v-col cols="4" class="pa-0">
              <v-card-text class="pa-0 text-red text-body-2">- {{formatAmt(item.dc_amt)}}</v-card-text>
            </v-col>
          </v-row>
          <v-row class="pl-1 pr-1 text-end">
            <v-col cols="12" class="pa-0">
              <v-card-text class="pa-0 text-body-1 font-weight-bold">{{formatAmt(item.sale_amt)}}</v-card-text>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <v-card class="pa-2 mt-2" color="grey-lighten-3" variant="flat">
        <div class="d-flex pa-1">
          <v-card-text class="pa-0 text-start text-body-1 font-weight-bold">총 상품 금액</v-card-text>
          <v-card-text class="pa-0 text-end text-body-1 font-weight-bold">{{formatAmt(totalProductPrice)}}</v-card-text>
        </div>
      </v-card>

      <v-card class="mt-4 pa-2" color="grey-darken-1" variant="outlined">
        <v-card-text class="pa-0 text-body-2 text-start">
          최종결제시 <b>수령방법</b>에 따라 <b>배송비</b>가 발생할수 있습니다.
        </v-card-text>
      </v-card>
    </v-container>

    <v-divider class="mt-4 mb-3"></v-divider>

    <v-container v-if="isVisibleReceivingMethods" class="mb-3 pt-0 pb-0" fluid>
      <v-row class="ma-0">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            수령방법
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-select
              :items="receivingMethods"
              item-title="name"
              item-value="code"
              v-model="receivingMethod"
              class="bg-white"
              density="compact"
              variant="outlined"
              location="bottom"
              label="수령방법 선택"
              single-line
              hide-details></v-select>
        </v-col>
      </v-row>
    </v-container>

    <v-divider class="mt-3 mb-3"></v-divider>

    <v-container v-if="isVisibleReceivingMethods" class="pt-0 pb-0" fluid>
      <v-row class="ma-0">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            주문자
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-text-field label="주문자명을 입력해주세요." maxlength="30" v-model="orderName" class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
        </v-col>
      </v-row>

      <v-row class="ma-0 mt-2">
        <v-col cols="4"></v-col>
        <v-col cols="8" class="pa-0">
          <v-checkbox density="compact" @click="flag = setSameReceiver(flag)" hide-details>
            <template v-slot:label>
              <div class="text-body-2">
                주문자와 동일
              </div>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>

      <v-row class="ma-0 mt-2">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            받는사람
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-text-field maxlength="30" v-model="receiverName" class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
        </v-col>
      </v-row>

      <v-row class="ma-0 mt-2">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            연락처
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-text-field maxlength="20" v-model="receiverPhoneNumber" class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
        </v-col>
      </v-row>

      <div v-if="receivingMethod === '001'">

        <v-row class="ma-0 pt-2">
          <v-col cols="2" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              호텔/콘도
            </v-card-text>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="pa-0">

            <v-select v-if="this.isRoute"  disabled="true"
                :items="routeUpjangMethods"
                item-title="name"
                item-value="code"
                v-model="routeUpjangMethod"
                class="bg-white"
                density="compact"
                variant="outlined"
                location="bottom"
                label="호텔/콘도 선택"
                single-line
                hide-details></v-select>

            <v-select v-if="!this.isRoute"
                      :items="routeUpjangMethods"
                      item-title="name"
                      item-value="code"
                      v-model="routeUpjangMethod"
                      class="bg-white"
                      density="compact"
                      variant="outlined"
                      location="bottom"
                      label="호텔/콘도 선택"
                      single-line
                      hide-details></v-select>
          </v-col>
        </v-row>
        <v-row class="ma-0 mt-2">
          <v-col cols="2" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              객실주소
            </v-card-text>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="pa-0">

            <v-text-field v-if="this.isRoute"
                v-model="payInfo.roomAddress"
                maxlength="50" class="pa-0" disabled="true" density="compact" variant="outlined" single-line hide-details></v-text-field>

            <v-text-field v-if="!this.isRoute"
                          v-model="payInfo.roomAddress"
                          maxlength="50" class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
          </v-col>
        </v-row>
      </div>

      <div v-if="receivingMethod === '002'">
        <v-row class="ma-0 mt-2">
          <v-col cols="2" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              수령시간
            </v-card-text>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="pa-0">
            <v-text-field v-model="payInfo.takeOutTime"
                          type="time"
                          class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
          </v-col>
        </v-row>
      </div>

      <div v-if="receivingMethod === '003'">
        <v-row class="ma-0 mt-2">
          <v-col cols="2" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              배송지
            </v-card-text>
          </v-col>
          <v-col cols="1"></v-col>
          <v-col cols="6" class="pa-0">
            <v-text-field
                v-model="payInfo.zonecode"
                disabled="true"
                maxlength="50" class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
          </v-col>
          <v-col cols="3" class="pa-0 text-end align-self-center">
            <v-btn
                class="bg-white"
                @click.prevent="openPostCode"
                variant="outlined">
              검색
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="ma-0 mt-2">
          <v-col cols="12" class="pa-0">
            <v-text-field
                v-model="payInfo.roadAddress"
                disabled="true"
                maxlength="50" class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
          </v-col>
        </v-row>
        <v-row class="ma-0 mt-2">
          <v-col cols="12" class="pa-0">
            <v-text-field
                v-model="payInfo.detailAddress"
                maxlength="50" class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
          </v-col>
        </v-row>
      </div>

      <div v-if="receivingMethod === '004'">
        <v-row class="ma-0 mt-2">
          <v-col cols="2" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              테이블번호
            </v-card-text>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="pa-0">
            <v-text-field v-if="this.isRoute"
                v-model="payInfo.tableNumber"
                maxlength="50" class="pa-0" density="compact" disabled="true" variant="outlined" single-line hide-details></v-text-field>
            <v-text-field v-if="!this.isRoute"
                          v-model="payInfo.tableNumber"
                          maxlength="50" class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
          </v-col>
        </v-row>
      </div>

      <div v-if="receivingMethod === '005'">
        <v-row class="ma-0 mt-2">
          <v-col cols="2" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              픽업시간
            </v-card-text>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="pa-0">
            <v-text-field v-model="payInfo.pickupTime"
                          type="time"
                          class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
          </v-col>
        </v-row>
      </div>

         <div v-if="receivingMethod === '007'">
              <v-row class="ma-0 mt-2">
                <v-col cols="2" class="pa-0 text-start align-self-center">
                  <v-card-text class="pa-0 font-weight-bold text-body-2">
                    픽업시간
                  </v-card-text>
                </v-col>
                <v-col cols="2"></v-col>
                <v-col cols="8" class="pa-0">
                  <v-text-field v-model="payInfo.pickupTime"
                                type="time"
                                class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
                </v-col>
              </v-row>
            </div>

      <v-row class="ma-0 mt-2">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            요청사항
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-text-field
              v-model="payInfo.requestMsg"
              class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
        </v-col>
      </v-row>

      <v-row class="ma-0 mt-2">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            추천인
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-text-field
              v-model="payInfo.recommender"
              maxlength="50" class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-divider class="mt-4 mb-3"></v-divider>

    <v-container class="pt-0 pb-4" fluid>
      <v-row class="ma-0 pb-2">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            결제방법
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-select
              :items="paymentMethods"
              item-title="name"
              item-value="code"
              v-model="paymentMethod"
              class="bg-white"
              density="compact"
              variant="outlined"
              location="bottom"
              label="결제방법 선택"
              single-line
              hide-details></v-select>
        </v-col>
      </v-row>

      <div v-if="this.upjangInfo.agree_privacy_html">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <v-checkbox v-model="agree_privacy" density="compact" hide-details>
              <template v-slot:label>
                <div class="text-body-2">
                  [필수] 개인정보 제3자 제공에 동의합니다.
                  <v-dialog v-model="dialog2" transition="dialog-bottom-transition">
                    <template v-slot:activator="{ props }">
                      <a class="font-weight-bold text-decoration-underline" @click="dialog2 = true">보기</a>
                    </template>
                    <v-card>
                      <v-card-text>
                        <p v-html="upjangInfo.agree_privacy_html"></p>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            class="text-primary font-weight-bold"
                            variant="text"
                            @click="[agree_privacy = false, dialog2 = false]"
                        >
                          미동의
                        </v-btn>
                        <v-btn
                            class="text-primary font-weight-bold"
                            variant="text"
                            @click="[agree_privacy = true, dialog2 = false]"
                        >
                          동의
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
      </div>

      <div v-if="this.upjangInfo.agree_pg_html">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <v-checkbox v-model="agree_pg" density="compact" hide-details>
              <template v-slot:label>
                <div class="text-body-2">
                  [필수] 결제대행서비스 이용약관에 동의합니다.
                  <v-dialog v-model="dialog3" transition="dialog-bottom-transition">
                    <template v-slot:activator="{ props }">
                      <a class="font-weight-bold text-decoration-underline" @click="dialog3 = true">보기</a>
                    </template>
                    <v-card>
                      <v-card-text>
                        <p v-html="upjangInfo.agree_pg_html"></p>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            class="text-primary font-weight-bold"
                            variant="text"
                            @click="[agree_pg = false, dialog3 = false]"
                        >
                          미동의
                        </v-btn>
                        <v-btn
                            class="text-primary font-weight-bold"
                            variant="text"
                            @click="[agree_pg = true, dialog3 = false]"
                        >
                          동의
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
      </div>

      <v-card class="pa-2 mt-2" color="grey-lighten-3" variant="flat">
        <v-container fluid>
          <v-row class="pa-1">
            <v-col cols="8" class="pa-0 text-start">
              <v-card-text class="pa-0 text-body-2">총 상품 금액</v-card-text>
            </v-col>
            <v-col cols="4" class="pa-0 text-end">
              <v-card-text class="pa-0 text-body-2">{{formatAmt(totalProductPrice)}}</v-card-text>
            </v-col>
          </v-row>
          <v-row v-if="isDelivery" class="pa-1">
            <v-col cols="8" class="pa-0 text-start">
              <v-card-text class="pa-0 text-body-2">배송비</v-card-text>
            </v-col>
            <v-col cols="4" class="pa-0 text-end">
              <v-card-text class="pa-0 text-body-2">{{formatAmt(upjangInfo.df)}}</v-card-text>
            </v-col>
          </v-row>
          <v-row class="pa-1 text-end">
            <v-col cols="8" class="pa-0 text-start">
              <v-card-text class="pa-0 text-body-1 font-weight-bold">최종 결제 금액</v-card-text>
            </v-col>
            <v-col cols="4" class="pa-0 text-end">
              <v-card-text class="pa-0 text-body-1 font-weight-bold">{{formatAmt(totalPrice) || '-'}}</v-card-text>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

<!--      TODO : 주문정보 -->
<!--      <v-card class="mt-4 pa-2" color="grey-darken-1" variant="outlined">-->
<!--        <v-card-text class="pa-0 text-body-2 text-start">-->
<!--          주문 안내안내안내-->
<!--        </v-card-text>-->
<!--      </v-card>-->
    </v-container>

    <v-row v-if="!this.$vuetify.display.mobile" class="mt-5">
      <v-col cols="6" class="pl-0 pr-0">
        <v-card-actions class="justify-end">
          <v-btn size="large" class="w-50 text-body-2 bg-primary" @click="resetOrder">주문초기화</v-btn>
        </v-card-actions>
      </v-col>
      <v-col cols="6" class="pl-0 pr-0">
        <v-card-actions class="justify-start">
          <v-btn size="large" class="w-50 text-body-2 bg-primary" @click="order">주문결제</v-btn>
        </v-card-actions>
      </v-col>
    </v-row>
  </v-card>

  <v-card
      flat
      v-if="items.length <= 0"
      rounded="0"
      class="mx-auto mt-4"
      max-width="800"
      mim-width="350">
    <v-card class="ma-4" color="grey-lighten-4" flat>
      <v-card-text class="text-body-2 text-center">
        결제할 상품이 없습니다.
      </v-card-text>
      <v-card-text class="pt-0 text-center">
        <v-btn color="primary" to="/upjang" variant="tonal" size="small">주문하러가기</v-btn>
      </v-card-text>
    </v-card>
  </v-card>

  <v-bottom-navigation
      v-if="this.$vuetify.display.mobile"
      class="bg-primary">
    <v-btn class="w-50 text-body-2" @click="resetOrder">주문초기화</v-btn>
    <v-btn class="w-50 text-body-2" @click="order">주문결제</v-btn>
  </v-bottom-navigation>
</template>

<script>
import authStore from "@/store/auth";
import {auth, cart, common, main, order, upjang} from "@/api";
import commonStore from "@/store/common";
import cartStore from "@/store/cart";
import payStore from "@/store/pay";
import shotUrlStore from "@/store/shotUrl";
import dayjs from "dayjs";

export default {
  name: "Order",
  data () {
    return {
      isAuth: false,
      isAuthClickBtn: false,
      isSmsClickBtn: false,
      agree: false,
      orderName: '',
      orderPhoneNumber: '',
      smsAuthNumber: '',
      timer: null,
      timeCounter: 0,
      timerStr: '',
      interval: null,
      dialog: false,
      dataReceived: false,
      isRoute: false,

      membershipInfo: [],
      selectedMembership: '',

      flag: true,
      isVisibleReceivingMethods: true,
      receivingMethods: [],
      receivingMethod: null,
      receiverName: '',
      receiverPhoneNumber: '',
      isDelivery: false,

      items: [],
      upjangInfo: {},
      paymentMethods: [],
      paymentMethod:  null,
      totalProductPrice: 0,
      totalPrice: 0,


      routeUpjangMethods: [],
      routeUpjangMethod:  null,

      payInfo: {},
      board: '',
      paymentCardSetting: '',
      dcInfo: '',
      apiTrxseq : '',
      discountResultMessage: '할인수단 또는 쿠폰을 선택해주세요.',

      agree_privacy: false,
      dialog2: false,
      agree_pg: false,
      dialog3: false,
    }
  },
  computed: {
    isAuth() {
      return authStore.state.authInfo.token !== null
    },
    isDelivery() {
      if (this.upjangInfo.delivery_fee === 'Y' && (this.receivingMethod === '001' || this.receivingMethod === '003')) {
        if (this.upjangInfo.free_delivery_bamt > 1 && this.upjangInfo.free_delivery_bamt <= this.totalProductPrice) {
          this.totalPrice = this.totalProductPrice
          return false
        } else {
          this.totalPrice = (parseInt(this.totalProductPrice) + parseInt(this.upjangInfo.df)).toString()
          return true
        }
      } else {
        this.totalPrice = this.totalProductPrice
        return false
      }
    },
  },
  created() {
    this.isAuth = authStore.state.authInfo.token !== null
    console.log('authStore.state.authInfo.name', authStore.state.authInfo.name)
    if (authStore.state.authInfo.token !== null) {
      this.orderName = authStore.state.authInfo.name
    }
    this.getAgreementInfo()
    this.getCartItemList()
    this.checkCart()

    if (shotUrlStore.state.routerInfo.dynamicParam) {
      this.isRoute = true
      this.payInfo.tableNumber = shotUrlStore.state.routerInfo.dynamicParam
      this.payInfo.roomAddress = shotUrlStore.state.routerInfo.dynamicParam
    }
  },
  methods: {
    getCommonCode(code) {
      return common.getCommonCode(commonStore.state.common.corpCode, [code])
          .then(data => {
            console.log(data)
            const codes = [];
            if (data.data.codes) {
              data.data.codes.forEach(item => {
                codes.push({code: item.detail, name: item.detail_name})
              })
            }
            return codes
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
            return []
          })
    },
    getAgreementInfo() {
      main.getNoticeList(commonStore.state.common.corpCode, 'agree')
          .then(data => {
            console.log('agree', data)
            this.board = data.data.notices[0].comment
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    onSendSMS() {
      // if (!this.orderName) {
      //   alert("주문하시는 분의 성함을 입력해주세요.")
      //   return
      // }

      if (!(/^\d{10}$|^\d{11}$/).test(this.orderPhoneNumber)) {
        alert("휴대번호를 다시 확인해주시기 바랍니다.")
        return
      }

      this.isSmsClickBtn = true
      this.isAuthClickBtn = true
      setTimeout(() => (this.isAuthClickBtn = false), 20000)

      auth.sendSMS(this.orderPhoneNumber)
          .then(data => {
            console.log(data)
            if (data.data.is_send === true) {
              this.timerStart()
            } else {
              this.timerClear()
              alert("SMS 전송에 실패했습니다.")
            }
          })
          .catch(err => {
            if (err.isAlert) {
              this.timerClear()
              alert(err.result.error_message)
            }
          })
    },
    onLogin() {
      if (!this.agree) {
        alert("정보제공에 동의해주세요.")
        return
      }

      if (!(this.timeCounter > 0
          && this.agree
          && (/^\d{10}$|^\d{11}$/).test(this.orderPhoneNumber) && (/^\d{4}$/).test(this.smsAuthNumber))) {
        alert("다시 인증해주세요.")
        return
      }

      const data = {
        phone_number: this.orderPhoneNumber,
        sms_auth_number: this.smsAuthNumber
      }
      authStore.dispatch('login', data)
          .then(result => {
            console.log(result)
            this.timerClear()
            this.orderPhoneNumber = authStore.state.authInfo.phoneNumber
            this.getMembershipInfo()
            this.isAuth = true
            alert("인증되었습니다.")
          })
          .catch(result => {
            console.log(result)
            this.isAuth = false
            alert("인증에 실패하셨습니다.")
          })
    },
    timerStart: function() {
      this.timerClear()
      this.timerStr = "03:00"
      this.timeCounter = 180

      // 1초에 한번씩 start 호출
      this.interval = setInterval(() => {
        this.timeCounter--; //1초씩 감소
        this.timerStr = this.prettyTime();
        if (this.timeCounter <= 0) this.timerClear();
      }, 1000);

      return this.interval
    },
    timerClear: function () {
      if (this.interval != null) {
        clearInterval(this.interval)
      }
      if(this.timer != null){
        this.timeCounter = 0;
        this.timer = null;
      }
      this.timerStr = "00:00";
    },
    prettyTime: function() {
      // 시간 형식으로 변환 리턴
      let t = this.timeCounter / 60;
      let minutes = parseInt(t);
      let secondes = Math.round((t - minutes) * 60);
      return (
          minutes.toString().padStart(2, "0") +
          ":" +
          secondes.toString().padStart(2, "0")
      );
    },
    getMembershipInfo() {
      this.membershipInfo = []
      auth.getDiscountMembershipInfo(commonStore.state.common.corpCode, this.upjangInfo.upjang_code)
          .then(data => {
            console.log(data)
            if (data.data.memberships) {
              data.data.memberships.forEach((item,index) => {
                this.membershipInfo.push({key:index+1, value:item.CDCNO, item:item})
              })
            }
            console.log(this.membershipInfo)
          })
          .catch(err => {
            console.log(err)
          })
    },
    getDiscountAmount() {
      if(this.selectedMembership === "") {
        return
      }
      this.discountResultMessage = ''

      order.getOrderPrice(commonStore.state.common.corpCode, cartStore.state.cart.cartKey, this.membershipInfo[this.selectedMembership-1].item.REF1)
          .then(data => {
            console.log(data)
            if (data.data.prices) {
              this.totalProductPrice = 0
              this.items = []

              data.data.prices.forEach((item) => {
                this.items.push({
                  menu_name: item.MENU_NAME,
                  sale_cnt: item.SALE_CNT,
                  unit_price: item.SALE_PRICE,
                  dc_rate: item.DC_RATE,
                  dc_amt: item.DC_AMT,
                  sale_amt: item.SALE_AMT,
                  cart_key: item.CART_KEY
                })

                this.totalProductPrice += item.SALE_AMT
              })
              this.discountResultMessage = '정상처리 되었습니다.'
              this.apiTrxseq = data.data.prices[0].API_TRXSEQ
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              this.apiTrxseq = ''
              this.selectedMembership = ''

              this.getCartItemList()

              this.discountResultMessage = err.result.error_message || '할인처리에 실패하였습니다.'
            }
          })

    },
    getCartItemList() {
      cart.getCartItemList(commonStore.state.common.corpCode, cartStore.state.cart.cartKey)
          .then(data => {
            console.log(data)
            if (data.data.items && data.data.items.length > 0) {
              this.totalProductPrice = 0
              this.items = []
              this.selectedMembership = ''
              this.isVisibleReceivingMethods = false

              data.data.items.forEach((item) => {
                this.items.push({
                  menu_name: item.menu_name,
                  sale_cnt: item.sale_cnt,
                  unit_price: item.sale_price,
                  sale_amt: item.sale_amt,
                  dc_rate: 0,
                  dc_amt: 0,
                  cart_key: item.cart_key
                })

                this.totalProductPrice += item.sale_amt
                // 주문 수령에 PRD_TYPE: 006(모바일티켓) 상품만 있는경우 주문 수령 메뉴 입력 받지 않음
                if (item.prd_type !== "006") {
                  this.isVisibleReceivingMethods = true
                }
              })

              // this.upjangInfo.minimum_oamt = parseInt(data.data.minimum_oamt)
              // this.upjangInfo.upjang_code = data.data.upjang_code

              if (this.isAuth) {
                this.getDiscountAmount()
              }
            }

            if (data.data.upjang_code) {
              this.getUpjangInfo(data.data.upjang_code)
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    getUpjangInfo(upjangCode) {
      if (!upjangCode) {
        return
      }

      upjang.getUpjangInfo(commonStore.state.common.corpCode, upjangCode)
          .then(data => {
            console.log('getUpjangInfo', data)
            if (data.data) {
              this.upjangInfo = data.data

              // 할인정보 조회에 영업장정보가 필요함. 영업장조회 후 할인정보 조회
              if (authStore.state.authInfo.token !== null) {
                this.orderPhoneNumber = authStore.state.authInfo.phoneNumber
                this.getMembershipInfo()
              }

              let rcvTypes = '';
              // 영업장별 수령정보
              if (shotUrlStore.state.routerInfo.rcvTypes) {

                if (shotUrlStore.state.routerInfo.rcvTypes != "") {
                  rcvTypes = shotUrlStore.state.routerInfo.rcvTypes
                } else {
                  rcvTypes = this.upjangInfo.rcv_types
                }
              } else if (this.upjangInfo.rcv_types) {
                rcvTypes = this.upjangInfo.rcv_types
              }
              if (rcvTypes) {
                this.receivingMethods = []
                this.getCommonCode('UC002')
                    .then(commonCodes => {
                      commonCodes.forEach(data => {
                        rcvTypes.forEach((code) => {
                          if (data.code === code) {
                            this.receivingMethods.push(data)
                          }
                        })
                      })
                    })
              }

              let calcTypes = '';
              // 영업장별 결제방식
              if (shotUrlStore.state.routerInfo.calcTypes) {
                if (shotUrlStore.state.routerInfo.calcTypes != "") {
                  calcTypes = shotUrlStore.state.routerInfo.calcTypes
                } else {
                  calcTypes = this.upjangInfo.calc_types
                }
              } else if (this.upjangInfo.calc_types) {
                calcTypes = this.upjangInfo.calc_types
              }
              if (calcTypes) {
                this.paymentMethods = []
                this.getCommonCode('UC001')
                    .then(commonCodes => {
                      commonCodes.forEach(data => {
                        calcTypes.forEach((code) => {
                          if (data.code === code) {
                            this.paymentMethods.push(data)
                          }
                        })
                      })
                    })
              }

              this.routeUpjangMethods = []
              this.getCommonCode('CK002')
                  .then(commonCodes => {
                    commonCodes.forEach(data => {
                          this.routeUpjangMethods.push(data)
                      })
                    if (shotUrlStore.state.routerInfo.dynamicParamUpjang) {
                      this.routeUpjangMethod = shotUrlStore.state.routerInfo.dynamicParamUpjang
                    }

                  })
              // TODO : 다이나믹파라미터 처리필요
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    setSameReceiver(flag) {
      if (flag) {
        this.receiverName = this.orderName
        this.receiverPhoneNumber = this.orderPhoneNumber
      } else {
        this.receiverName = ''
        this.receiverPhoneNumber = ''
      }
      return !flag
    },
    resetOrder() {
      if (!this.items.length || this.items.length <= 0) {
        alert("결제할 상품이 없습니다.\n상품 주문 페이지로 이동하겠습니다.")
        this.$router.push('/upjang')
        return
      }

      if (confirm("모든 주문 정보가 초기화 됩니다. 계속하시겠습니까? ") === true){
        cartStore.dispatch('removeCartInfo')
        shotUrlStore.dispatch('removeRouterInfo')
        this.$router.push('/upjang')
      }
    },
    openPostCode() {
      new window.daum.Postcode({
        oncomplete: (data) => {
          console.log(data)
          this.payInfo.zonecode = data.zonecode
          this.payInfo.roadAddress = data.roadAddress
        }
      }).open()
    },
    order() {
      if (!this.items.length || this.items.length <= 0) {
        alert("결제할 상품이 없습니다.\n상품 주문 페이지로 이동하겠습니다.")
        this.$router.push('/upjang')
        return
      }

      if (this.upjangInfo.minimum_oamt > this.totalProductPrice) {
        alert("최소 주문금액은 " + this.formatAmt(this.upjangInfo.minimum_oamt) + " 입니다.")
        return
      }

      if (!this.validationOrderInput()) {
        return
      }

      if(this.selectedMembership) {
        this.dcInfo = this.membershipInfo[this.selectedMembership-1].item.REF1

        if (this.paymentMethod != '001' && this.membershipInfo[this.selectedMembership-1].item.REF2 === '6') {
          alert("카드할인을 적용하시려면 신용카드로 결제 하여야합니다.\n결제방법을 확인해주세요.")
          return
        }

        if(this.membershipInfo[this.selectedMembership-1].item.REF2 === '6') {
          this.paymentCardSetting = this.membershipInfo[this.selectedMembership-1].item.REF4
        }
      }

      // 모바일티켓으로만 되어있는 경우 수령방법은 ‘006’으로 전달
      if (!this.isVisibleReceivingMethods) {
        this.receivingMethod = "006"
      }

      var routeUpjangMethodText = ""
      if(this.payInfo.roomAddress) {
        this.routeUpjangMethods.forEach(data => {
          if(this.routeUpjangMethod == data.code) {
            routeUpjangMethodText = data.name + "_"

          }
        })
      }


      const request = {
        corp_code: commonStore.state.common.corpCode,
        cart_key: this.items[0].cart_key,
        select_rcv: this.receivingMethod,
        select_calc: this.paymentMethod,
        upjang_code: this.upjangInfo.upjang_code || '',
        parcel_receipt_name: this.receiverName,
        parcel_receipt_hp_no: this.receiverPhoneNumber,
        request_msg: this.payInfo.requestMsg || '',
        select_rcv_outlet: routeUpjangMethodText + this.payInfo.roomAddress || '',
        rcv_msg: '',
        table_no: this.payInfo.tableNumber || '',
        parcel_order_name: this.orderName || '',
        parcel_addr: this.payInfo.roadAddress || '',
        parcel_addr_detail: this.payInfo.detailAddress || '',
        parcel_post_no: this.payInfo.zonecode || '',
        parcel_recm_name: this.payInfo.recommender || '',
        send_out_date: '', // 배송요청일 -> 수령시간/픽업시간 이 필요,
        dc_info: this.dcInfo, // 할인적용근거
        api_trxseq : this.apiTrxseq, // 기간계 DC처리 순번
        payment_card_setting: this.paymentCardSetting
      }

      console.log('payreqeust', request)


      if (this.paymentMethod === '001') {
        // 신용카드
        payStore.dispatch('setPayInfo', request)
            .then(() => {
              this.$router.push('/pay')
            })
            .catch(() => {
            })
      } else {
        order.makeOrderInfo(request)
            .then(data => {
              console.log(data)
              if (data.data && !this.dataReceived) {
                this.dataReceived = true;
                authStore.dispatch('setName', this.orderName)
                cartStore.dispatch('removeCartInfo')
                shotUrlStore.dispatch('removeRouterInfo')
                this.$router.push('/order/' + data.data.sale_date + '/' + data.data.bill_no + '/' + data.data.upjang_code)
              }
            })
            .catch(err => {
              console.log(err)
              if (err.isAlert) {
                alert(err.result.error_message)
              }
            })
      }
    },
    validationOrderInput() {

      if (!this.isAuth) {
        alert("휴대폰 인증이 필요합니다.")
        return false
      }

      if(this.isVisibleReceivingMethods) {
        if (!this.receivingMethod) {
          alert("수령방법을 선택해주세요.")
          return false
        }

        this.orderName = this.orderName.trim() // 주문자
        this.orderPhoneNumber = this.orderPhoneNumber.trim() // 연락처
        this.receiverName = this.receiverName.trim() // 받는사람
        this.receiverPhoneNumber = this.receiverPhoneNumber.trim() // 연락처

      } else {
        // 티켓구매의 경우 별도 입력 없음
        this.orderName = '티켓'
        this.receiverName = '티켓'
        this.orderPhoneNumber = this.orderPhoneNumber.trim() // 연락처
        this.receiverPhoneNumber = this.orderPhoneNumber
        this.receiverPhoneNumber = this.receiverPhoneNumber.trim() // 연락처
      }

      if (!this.orderName) {
        alert("주문하시는 분의 성함을 입력해주세요.")
        return false
      }
      if (!this.orderPhoneNumber) {
        alert("주문하시는 분의 연락처를 입력해주세요.")
        return false
      }
      if (!this.receiverName) {
        alert("받으시는 분의 성함을 입력해주세요.")
        return false
      }
      if (!this.receiverPhoneNumber) {
        alert("받으시는 분의 연락처를 입력해주세요.")
        return false
      }




      if (!this.paymentMethod) {
        alert("결제방법을 선택해주세요.")
        return false
      }

      // 수령방법코드
      if (this.receivingMethod === '001') { // 배달사용

        if (!this.routeUpjangMethod) {
          alert("수령 받으실 호텔 또는 콘도를 선택해주세요.")
          return false
        }
        if (!this.payInfo.roomAddress) {
          alert("객실주소를 입력해주세요.")
          return false
        }
      } else if (this.receivingMethod === '002') { // 포장사용
        /*
        if (!this.payInfo.takeOutTime) {
          alert("수령시간을 입력해주세요.")
          return false
        }
         */
        if(this.payInfo.takeOutTime) {
          if (dayjs().isAfter(dayjs(dayjs().format('YYYY-MM-DD') + ' ' + this.payInfo.takeOutTime))) {
            alert("수령시간을 지금 시간보다 이후로 설정해주세요.")
            return false
          }
        }
      } else if (this.receivingMethod === '003') { // 택배주문
        if (!this.payInfo.zonecode || !this.payInfo.roadAddress || !this.payInfo.detailAddress) {
          alert("주소를 입력해주세요.")
          return false
        }
      } else if (this.receivingMethod === '004') { // 현장주문
        if (!this.payInfo.tableNumber) {
          alert("테이블번호를 입력해주세요.")
          return false
        }
      } else if (this.receivingMethod === '005') { // 주문예약
        if (!this.payInfo.pickupTime) {
          alert("수령시간을 입력해주세요.")
          return false
        }

        if (dayjs().isAfter(dayjs(dayjs().format('YYYY-MM-DD') + ' ' + this.payInfo.pickupTime))) {
          alert("수령시간을 지금 시간보다 이후로 설정해주세요.")
          return false
        }
      }

      if (this.upjangInfo.agree_privacy_html && !this.agree_privacy) {
        alert("개인정보 제3자 제공에 동의가 필요합니다.")
        return false
      }
      if (this.upjangInfo.agree_pg_html && !this.agree_pg) {
        alert("결제대행서비스 이용약관에 동의가 필요합니다.")
        return false
      }

      return true
    },
    checkCart() {
      cart.checkCart(commonStore.state.common.corpCode, cartStore.state.cart.cartKey)
          .then(data => {
            console.log(data)
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
              cartStore.dispatch('removeCartInfo')
              shotUrlStore.dispatch('removeRouterInfo')
              this.$router.push('/upjang')
            }
          })
    },
  }
}
</script>

<style scoped>

</style>
